import { FormControl, Grid, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useState } from 'react';
import useSWR from 'swr';
import { getPlatformEnableProviderList } from '../api/cms/provider';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 200,
    maxWidth: 300,
    width: '100%',
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.9rem',
  },
  code: {
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
    fontSize: '0.8rem',
  },
}));

const DropdownActiveProvider = (props) => {
  const { data: providers } = useSWR('provider', () => getPlatformEnableProviderList());
  const [selectedProvider, setSelectedProvider] = useState('');
  const classes = useStyles();

  const handleChange = (event) => {
    setSelectedProvider(event.target.value);
    const p = providers.find((v) => v.provider_code === event.target.value);
    if (p) {
      props.handleCallback({
        provider_code: p.provider_code,
        provider_id: p.provider_id,
        provider_name: p.provider_name,
      });
    }
  };

  return (
    <>
      {providers ? (
        <Grid item xs={12}>
          <FormControl className={classes.formControl} variant="outlined" size="small">
            <InputLabel id="select-provider-label">Select Provider</InputLabel>
            <Select
              labelId="select-provider-label"
              id="select-provider"
              value={selectedProvider}
              onChange={handleChange}
            >
              {providers.map((v) => (
                <MenuItem
                  key={v.provider_code}
                  value={v.provider_code}
                  className={classes.menuItem}
                >
                  <span>{v.provider_name}</span>
                  <span className={classes.code}>({v.provider_code})</span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      ) : null}
    </>
  );
};

DropdownActiveProvider.propTypes = {
  handleCallback: PropTypes.func.isRequired,
};

export default DropdownActiveProvider;
